<div class="vertical-nav-container" [class.collapsed]="isCollapsed" [class.mobile]="isHandset">
  <!-- Header -->
  <div class="nav-header">
    @if (!isCollapsed && !isHandset) {
    <div class="nav-title">
      <div (click)="router.navigate(['/'])" class="nav-title-link">
        <img [src]="logoUrl" alt="JJames Smart Parking" class="nav-brand-logo" />
      </div>
    </div>
    }
    @if (true) {
    <button mat-icon-button (click)="toggleCollapse()" class="toggle-btn" [attr.aria-label]="'Toggle navigation'">
      <mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>
    }
  </div>

  <!-- Navigation Items -->
  <div class="nav-content">
    <mat-nav-list class="nav-list">
      @for (item of navigationItems; track item.id) {
      <lib-vertical-nav-item [item]="item" [isCollapsed]="isCollapsed" [level]="0" [isHandset]="isHandset">
      </lib-vertical-nav-item>
      }
    </mat-nav-list>
  </div>

  <!-- Footer with version and language selector -->
  @if (!isHandset) {
  <div class="nav-footer">
    <!-- Language selector (opt-in; visible collapsed and expanded) -->
    @if (showLanguageSwitcher) {
    <div class="nav-language" [class.collapsed]="isCollapsed">
      <lib-language-switcher [isCollapsed]="isCollapsed"></lib-language-switcher>
    </div>
    }
    @if (!isCollapsed) {
    <div class="footer-content">
      <!-- App Version -->
      <div class="app-version">
        <mat-icon class="version-icon">info</mat-icon>
        <small>Version 2.0.0</small>
      </div>
      @if (environment != undefined ) {
      <!-- Environment -->
      <div class="environment-info">
        <mat-icon class="env-icon">cloud</mat-icon>
        <small>{{ environment.environment }}</small>
      </div>
      }

      @if (isCollapsed) {
      <div class="collapsed-footer">
        <mat-icon matTooltip="JJames Smart Parking v2.0.0" matTooltipPosition="right">info</mat-icon>
      </div>
      }
    </div>
    }
  </div>
  }
  <!-- Mobile overlay removed - menu stays collapsed on mobile -->